import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { gpedPedidoInterface } from "../interfaces/gpedPedido.inteface";

export async function DeletePedidoAction(
  pedidoId: string
): Promise<ApiResponse<gpedPedidoInterface>> {
  const { data } = await apiClient.delete(`gpedPedido/${pedidoId}`);
  return {
    status: 200,
    data,
    message: "Pedido eliminado correctamente",
  };
}
    